import PrepaidPlanModal from './PrepaidPlanModal.vue'

export default PrepaidPlanModal
